import React from "react";
import { motion } from "framer-motion";
import { CalendarBlank } from "@phosphor-icons/react";
import CalendarBoard from "@/components/CalendarBoard";

export default function GuestCalendar({ entries }) {
  return (
    <section
      id="calendar"
      className="px-6 sm:px-10 lg:px-16 py-24 md:py-32 border-b border-border"
      data-testid="guest-calendar"
    >
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="inline-flex items-center gap-2 text-accent">
            <CalendarBlank size={20} weight="duotone" />
            <span className="subhead text-accent text-sm">Owners &amp; Manager</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl tracking-tight text-foreground mt-4">
            Booking Calendar
          </h2>
          <p className="text-muted-foreground mt-4 text-sm max-w-lg">
            Upcoming personal use, guest stays, and rentals at the house. Check-in is 4:00 PM and
            check-out is 10:00 AM. Read-only — contact the owners for any changes.
          </p>
          <div className="mt-10">
            <CalendarBoard entries={entries || []} />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
